export default __webpack_public_path__ + "static/media/11.ebb6695f.jpg";